import styled from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
var dark = colors.dark;
var size = font.size,
  weight = font.weight,
  family = font.family,
  lineHeight = font.lineHeight;
var px12 = size.px12,
  px14 = size.px14;
var bold = weight.bold;
var aspira = family.aspira;
export var DevicePolicyContainer = styled.div.withConfig({
  componentId: "sc-1wid8mm-0"
})(["color:", ";font-family:", ";"], dark, aspira);
export var DevicePolicyHeading = styled.h2.withConfig({
  componentId: "sc-1wid8mm-1"
})(["font-weight:", ";margin-bottom:5px;font-size:", ";"], bold, px14);
export var DevicePolicyText = styled.div.withConfig({
  componentId: "sc-1wid8mm-2"
})(["font-size:", ";margin-top:0;> p{margin-top:0;font-size:", ";line-height:", ";}"], px12, px12, lineHeight.md);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/DevicePolicy/styled.js
// module id = 3974
// module chunks = 11